import {Spacer, Tag, Stack, Checkbox } from '@chakra-ui/react'
import { useContext } from 'react'
import { useSearchParams } from 'react-router-dom'
import {TesterAdd} from '../../../Testers/TesterAdd/TesterAdd'
import { CountingTabsContext } from '../../../CountingTabs/CountingTabs'

export const RowsCountedTableCaption = (props) => {
	const {amount, total, testers, addTester, totalTested} = props
	const [ searchParams ] = useSearchParams()
	const tab = searchParams.get('tab')
	const { revisedTabs, toggleRevisedTab } = useContext(CountingTabsContext)
	return (
		<Stack direction='row' spacing={4} >
			<Tag colorScheme='blue'>Total: {total}</Tag>
			<Tag colorScheme='green'>Amount: {amount}</Tag>
			<Tag colorScheme='purple'>Tested: {totalTested}</Tag>
			<Checkbox isChecked={ revisedTabs.includes(tab) } onChange={() => toggleRevisedTab(tab) }> Revised </Checkbox>
			<Spacer/>
			<TesterAdd testers={testers} addTester={addTester}/>

		</Stack>
	)
}